import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux'
import { Col, Row } from 'reactstrap'
import { ApplicationState } from 'store'
import { ATENDIMENTO } from 'store/modules/atendimento/types'
import * as atendimentoActions from 'store/modules/atendimento/actions'
import useRedux from 'hooks/useRedux'
import { AnswersFormularioNecessidade } from 'models/types'

const Imovel = () => {
  const { formularioNecessidade } = useSelector<ApplicationState, ATENDIMENTO>(
    (state) => state.atendimento
  )

  const [disabled, setDisabled] = useState(false)

  const { dispatch } = useRedux()

  type Fields = keyof AnswersFormularioNecessidade
  function onChange(value: boolean, field: Fields) {
    dispatch(atendimentoActions.setInfosFormulario(value, field))
  }

  function changeTab(tab: number) {
    dispatch(atendimentoActions.setTabFormulario(tab))
  }

  function proximo() {
    changeTab(4)
  }

  useEffect(() => {
    if (!formularioNecessidade.answers.possuiImovel) {
      dispatch(atendimentoActions.setInfosFormulario(false, 'imovelQuitado'))
      setDisabled(true)
    } else {
      setDisabled(false)
    }
  }, [dispatch, formularioNecessidade.answers.possuiImovel])

  return (
    <div className="container-fluid">
      <div className="container-formulario">
        <Row>
          <Col className="d-flex flex-column align-items-center">
            <label className="label-12">Possui imóvel?</label>
            <label className="switch">
              <input
                checked={formularioNecessidade.answers.possuiImovel}
                onChange={(e) => onChange(e.target.checked, 'possuiImovel')}
                type="checkbox"
              />
              <div className="sliderCheck round">
                <span className="on">SIM</span>
                <span className="off">NÃO</span>
              </div>
            </label>
          </Col>
        </Row>
        <Row>
          <Col className="d-flex flex-column align-items-center">
            <label className="label-12">Imóvel quitado?</label>
            <label className="switch">
              <input
                checked={formularioNecessidade.answers.imovelQuitado}
                onChange={(e) => onChange(e.target.checked, 'imovelQuitado')}
                disabled={disabled}
                type="checkbox"
              />
              <div className="sliderCheck round">
                <span className="on">SIM</span>
                <span className="off">NÃO</span>
              </div>
            </label>
          </Col>
        </Row>
      </div>
      <div className="d-flex justify-content-center column-gap-20">
        <div
          className="btn-outline-purple justify-content-center"
          onClick={() => changeTab(2)}
        >
          Voltar
        </div>
        <div
          className="btn-purple justify-content-center"
          onClick={() => proximo()}
        >
          Próximo
        </div>
      </div>
    </div>
  )
}

export default Imovel
